import React from "react"
import styled from "styled-components"

import { Link, ParagraphSmall } from "components/text"
import Icon from "components/icon"

const _BackLink = styled(Link)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`

export function BackLink({ to, text }: { to: string; text?: React.ReactNode }) {
  return (
    <_BackLink to={to}>
      <Icon name="backArrow" mr={3} />
      {text ? text : <ParagraphSmall>BACK</ParagraphSmall>}
    </_BackLink>
  )
}
